export const pagesAttendanceCoreEn = {
  archiveScreen: {
    description: 'Archived operation packages will appear here.',
    title: 'Archive'
  },
  configScreen: {
    kinds: {
      operationEvents: 'Business Operation Events',
      operationPackages: 'Operation packages'
    }
  },
  dashboard: {
    comparedToLastMonth: 'vs last month',
    gantt: {
      barLabels: {
        adjustmentProgress: 'Adjustment pending',
        approvalRatio: 'Line approvals: 18/24',
        clockInCoverage: 'Punches captured: 698/700',
        confirm: 'Confirm',
        confirmationProgress: 'Confirmation pending',
        handoffPending: 'Payroll handoff (scheduled)',
        lockedForPayroll: 'Period lock (scheduled)',
        missingPunchQueue: 'Missing punches: 12 open',
        overtimeAllocation: 'Overtime vs 36 agreement: 92%',
        solicitationProgress: 'Requests sent: 5/5 stores',
        staffingPlanProgress: 'Staffing plan: 6/6 stores',
        submissionProgress: 'Preferences in: 3/5 stores'
      },
      calendar: {
        moreCount: '+{{count}} more',
        nextPeriod: 'Next',
        noEventsThisWeek: 'No items in this window.',
        previousPeriod: 'Previous',
        status: {
          done: 'Done',
          inProgress: 'In progress',
          todo: 'Not started'
        },
        taskAria: '{{status}} — {{label}} — {{date}}',
        today: 'Today'
      },
      dataView: {
        assignees: {
          '0': 'Payroll / HR operations',
          '1': 'Attendance administration',
          '2': 'Corporate accounting',
          '3': 'IT / integrations'
        },
        attention: {
          no: '—',
          yes: 'Yes'
        },
        closureStatus: {
          draft: 'Draft',
          inReview: 'In review',
          locked: 'Locked'
        },
        emptyFiltered: 'No rows match the current filters.',
        exportToastTitle: 'Export is not available in preview.',
        fixtures: {
          departments: {
            d1: 'Sales Operations',
            d2: 'Store Operations',
            d3: 'Corporate HQ'
          },
          employees: {
            e1: 'Hanako Aoyama',
            e2: 'Taro Sato',
            e3: 'Yuki Nakamura',
            e4: 'Ken Ito',
            e5: 'Mei Fujita'
          },
          workplaces: {
            w1: 'Tokyo HQ',
            w2: 'Osaka Store',
            w3: 'Yokohama DC'
          }
        },
        readiness: {
          blocked: 'Blocked',
          pending: 'Pending checks',
          ready: 'Ready to close'
        },
        rowKinds: {
          event: 'Event',
          step: 'Step'
        },
        scopes: {
          byPlace: 'places',
          daily: 'Daily attendance',
          monthly: 'Employee'
        },
        searchPlaceholder: 'Search events, steps, or assignees',
        searchPlaceholderAttendance: 'Search by employee, date, workplace, or code',
        tabs: {
          all: 'All',
          attention: 'Needs attention',
          done: 'Done',
          inProgress: 'In progress'
        },
        workStatus: {
          leave: 'Paid leave',
          missingOut: 'Missing clock-out',
          normal: 'Normal'
        }
      },
      eventTitles: {
        flexWorkPolicyReview: 'Flex settlement period revision – starting June',
        monthlyClosingNovember: 'Monthly attendance close – June',
        monthlyClosingOctober: 'Monthly attendance close – May',
        partTimeMonthlyClosingMay: 'Monthly attendance close (part-time) – May',
        shiftOrganizationJun: 'Shift planning – June',
        shiftOrganizationJunSapporo: 'Shift planning – June (Sapporo)',
        shiftOrganizationJunTsukiji: 'Shift planning – June (Tsukiji)',
        shiftOrganizationMay: 'Shift planning – May',
        shiftOrganizationMaySapporo: 'Shift planning – May (Sapporo)',
        shiftOrganizationMayTsukiji: 'Shift planning – May (Tsukiji)'
      },
      loadError: 'Could not load the dashboard.',
      steps: {
        agreement36Check: '36-agreement & overtime check',
        collectTimeClockData: 'Collect time clock data',
        exportLockedTimesheet: 'Export locked timesheet',
        lockMonthlyAttendance: 'Lock monthly attendance',
        managerLineApprovals: 'Attendance manager approval',
        resolveMissingPunches: 'Month-end punch close request',
        shiftAdjustment: 'Shift adjustment',
        shiftConfirmation: 'Shift confirmation',
        shiftRequestSolicitation: 'Request shift preferences',
        shiftRequestSubmission: 'Collect shift preferences',
        staffingPlan: 'Staffing plan'
      },
      taskColumn: {
        filterAria: 'Filter task list',
        title: 'Attendance events & steps'
      },
      toolbar: {
        assignee: 'Assignee',
        assigneeSelf: 'Me',
        calendarPlacementByEvent: 'By event',
        calendarPlacementDeadline: 'By deadline',
        calendarPlacementLabel: 'Display',
        granularity: {
          month: 'Monthly',
          quarter: 'Quarterly',
          week: 'Weekly'
        },
        settingsAria: 'Gantt display settings',
        viewCalendar: 'Calendar',
        viewData: 'Data',
        viewGantt: 'Gantt'
      }
    },
    noMetrics: 'No metrics data available',
    startMockOperationEvent: {
      dialogTitle: 'Select an attendance structure and a run pattern',
      patternStep: {
        cards: {
          offCycle: {
            description: 'Applies corrections or additional processing outside the regular monthly close, such as re-opening a locked period or closing a mid-month joiner.',
            title: 'Off-cycle adjustment'
          },
          regular: {
            description: 'Runs the selected period through the regular monthly flow: punch import, aggregation, approval, lock, and payroll handoff.',
            title: '{{period}} — Regular close'
          }
        },
        label: 'Run pattern',
        loading: 'Loading run patterns…'
      },
      startNew: 'Start attendance close',
      structureStep: {
        label: 'Attendance structure',
        loading: 'Loading attendance structures…'
      }
    },
    title: 'Dashboard'
  },
  headerActions: {
    helpAria: 'Help',
    startNew: 'Start new'
  },
  operationEvents: {
    compare: {
      addVersion: 'Add a version',
      addVersionEmpty: 'Every version is already shown',
      changedFromRight: 'Differs from the version on the right',
      currentVersion: 'Current version',
      empty: 'There is no version to compare.',
      itemColumn: 'Attendance item',
      removeVersion: 'Remove from the comparison',
      sections: {
        dayCounts: 'Days and counts',
        summary: 'Total work hours',
        workTime: 'Work hours'
      },
      title: 'Version comparison'
    },
    data: {
      attendanceItems: {
        absenceDays: 'Absence (days)',
        actualHours: 'Total work (h)',
        holidayHours: 'Holiday work (h)',
        lateNightHours: 'Late night (h)',
        missingPunchCount: 'Missing punches (count)',
        overtimeHours: 'Overtime (h)',
        paidLeaveDays: 'Paid leave (days)',
        scheduledHours: 'Scheduled work (h)',
        tardinessCount: 'Late / early leave (count)',
        workingDays: 'Days worked (days)'
      },
      compare: 'Compare',
      edit: 'Edit',
      filters: {
        organization: 'Organization',
        organizationPlaceholder: 'Search organizations',
        place: 'Place',
        placePlaceholder: 'Search places'
      },
      organizations: {
        corporate: 'Corporate',
        logistics: 'Logistics',
        storeOperations: 'Store Operations'
      },
      places: {
        osakaStore: 'Osaka store',
        tokyoHq: 'Tokyo head office',
        yokohamaCenter: 'Yokohama distribution center'
      },
      searchPlaceholder: 'Search by name',
      sidebar: {
        close: 'Close side tab',
        open: 'Open side tab',
        title: 'Version'
      }
    },
    detail: {
      breadcrumbEvents: 'Events',
      description: 'Progress of the steps and tasks in this attendance close.',
      feed: {
        description: 'Pick a task from the list to open its detail.',
        title: 'No task selected'
      },
      filter: {
        clear: 'Clear',
        employee: 'Employee',
        label: 'Filter',
        organization: 'Organization',
        place: 'Place'
      },
      metrics: {
        closingDate: 'Closing date',
        progress: 'Progress',
        target: 'Target',
        targetUnit: 'employees',
        tasksUnit: 'tasks'
      },
      moreActionsAria: 'More actions',
      openTaskAria: 'Open task detail',
      sidebar: {
        allSteps: 'All operation steps',
        assigneeFilter: 'Assignee',
        close: 'Close side tab',
        open: 'Open side tab',
        searchPlaceholder: 'Filter by',
        statusFilter: 'Status',
        title: 'Steps and tasks',
        toggleStepAria: 'Toggle step tasks'
      },
      status: {
        cancelled: 'Cancelled',
        correctionRequired: 'Correction required',
        done: 'Done',
        evaluating: 'Evaluating',
        failed: 'Failed',
        inProgress: 'In progress',
        notStarted: 'Not started',
        reviewRequired: 'Review required'
      },
      stepDescription: 'description',
      table: {
        assignee: 'Assignee',
        dueDate: 'Due date',
        progress: 'Progress',
        progressCount: '{{completed}}/{{total}} {{unit}}',
        status: 'Status',
        taskName: 'Task name'
      },
      tabs: {
        data: 'Data',
        detail: 'Detail'
      },
      taskDetail: {
        approval: {
          flowTitle: 'Approval flow',
          rows: {
            attendancePeriod: 'Attendance period',
            closingDate: 'Closing date',
            closingExecutor: 'Closing executor',
            lateNightHours: 'Late night hours',
            overtimeHours: 'Overtime hours',
            payrollHandoff: 'Payroll handoff target',
            targetEmployeeCount: 'Target employees',
            totalWorkHours: 'Total work hours',
            unresolvedPunchEmployees: 'Employees with unresolved punches',
            withinScheduleHours: 'Within scheduled hours'
          },
          sections: {
            complianceCheck: 'Compliance Check',
            handoffInfo: 'Handoff Info',
            hoursBreakdown: 'Hours Breakdown',
            periodSummary: 'Period Summary'
          }
        },
        assignSomeoneElse: 'Assign someone else',
        assigneeLabel: 'Assignee',
        bulkActions: {
          approve: 'Bulk approve',
          cancel: 'Bulk cancel',
          confirm: 'Bulk confirm',
          disabledReasons: {
            evaluateCancel: 'Bulk cancel is unavailable because the selection includes items that are already confirmed (changes after confirmation are treated as a reopen).',
            evaluateConfirm: 'Bulk confirm is unavailable because the selection includes items that are not review required.',
            evaluateRecalculate: 'Recalculation is unavailable because the selection includes items that are already confirmed or cancelled.',
            operationCheckReconcile: 'Bulk reconcile is unavailable because the selection includes mismatched items. Review the differences first.'
          },
          recalculate: 'Bulk recalculate',
          reconcile: 'Bulk reconcile',
          reject: 'Bulk reject',
          remand: 'Bulk remand',
          toasts: {
            approved: '{{count}} approved',
            cancelled: '{{count}} cancelled',
            confirmed: '{{count}} confirmed',
            recalculated: '{{count}} recalculated',
            reconciled: '{{count}} marked as reconciled',
            rejected: '{{count}} rejected',
            remanded: '{{count}} remanded'
          }
        },
        completedToast: 'Task completed',
        confirm: 'Confirm',
        description: 'description',
        dueDateLabel: 'Due date',
        employeeCount: '{{count}} employees',
        evaluate: {
          editReasonLabel: 'Edit reason',
          editedAtLabel: 'Edited at',
          editedByLabel: 'Edited by',
          editedValueLabel: 'Value after edit',
          engineRunStatus: {
            failed: 'Failed',
            queued: 'Queued',
            running: 'Running',
            succeeded: 'Succeeded'
          },
          errorMessageLabel: 'Error details',
          inputValuesTitle: 'Input values',
          manualEditTitle: 'Manual edit',
          originalValueLabel: 'Value before edit',
          outputValuesTitle: 'Calculation results',
          recalculate: 'Recalculate',
          rerun: 'Re-run',
          runFinishedLabel: 'Finished at',
          runHistoryTitle: 'Run history',
          runStartedLabel: 'Started at',
          unitIdLabel: 'Unit ID',
          unitLabel: 'Referenced unit',
          viewFinalizedTableLabel: 'View finalized table'
        },
        form: {
          fieldLabel: 'Label',
          placeholder: 'Placeholder',
          validationError: 'Something went wrong...'
        },
        kinds: {
          approval: 'Approval task',
          evaluate: 'Calculation task',
          operation: 'Operation task',
          operationCheck: 'Reconciliation task'
        },
        multiTarget: {
          clearFilters: 'Clear filters',
          columns: {
            evaluate: {
              hasManualEdit: 'Manual edit',
              outputValue: 'Output value'
            },
            operationCheck: {
              actual: 'Actual value',
              expected: 'Expected value',
              matchResult: 'Match result'
            }
          },
          manualEditStates: {
            absent: '—',
            present: 'Yes'
          },
          matchStates: {
            matched: 'Matched',
            mismatched: 'Mismatched'
          },
          openTargetAria: 'Open this target’s task detail',
          selectAllAria: 'Select all rows',
          selectRowAria: 'Select this row',
          selectedCount: '{{count}} selected',
          targetColumn: 'Target'
        },
        setReminder: 'Set Reminder',
        table: {
          employee: 'Employee',
          organizationFilter: 'Organization',
          relatedColumn: 'Related item of the unit/task process',
          searchPlaceholder: 'Search by name...',
          workplaceFilter: 'Workplace'
        }
      },
      views: {
        feed: 'Feed',
        list: 'List'
      }
    },
    edit: {
      emptyFields: 'No item matches the selected conditions',
      emptyRecords: 'No employee matches',
      errorColumn: 'Error detail',
      fieldSearchPlaceholder: 'Search items',
      filters: {
        error: 'Errors',
        fixed: 'Fixed',
        noChange: 'No change'
      },
      issues: {
        lateNightHoursNegative: 'Late night hours cannot be negative',
        overtimeExceedsAgreement36: 'Overtime exceeds the 36-agreement monthly limit',
        workingDaysMissing: 'Days worked is required'
      },
      noChangeBanner: 'This employee has no change from the previous version, so it is skipped when saving.',
      noRecordSelected: 'Select an employee from the list on the left',
      notes: {
        edited: 'Edited',
        fixed: 'Fixed (revalidated on save)'
      },
      readOnlyItem: 'Calculated automatically',
      save: 'Save changes',
      saved: 'Saved',
      searchPlaceholder: 'Search by name',
      sections: {
        dayCounts: 'Days and counts',
        summary: 'Totals',
        workTime: 'Work hours'
      },
      toggleEditAria: 'Toggle editing',
      views: {
        profile: 'Profile',
        table: 'Table'
      }
    },
    instanceEmptyState: {
      description: 'Use “Start new” to start a business event.',
      title: 'No business events'
    },
    patternEmptyState: {
      description: 'No patterns are registered for this business event yet.',
      title: 'No patterns'
    },
    patterns: {
      fullTimeMonthlyClosing: 'Monthly close for full-time employees',
      partTimeMonthlyClosing: 'Monthly close for part-time employees',
      storeShiftPlanning: 'Store shift planning'
    },
    sidebar: {
      agreement36Operation: '36-agreement operations',
      monthlyClosing: 'Monthly attendance close',
      shiftOrganization: 'Shift planning'
    },
    table: {
      eventName: 'Business Operation Event',
      progress: 'Progress'
    }
  },
  operationPackages: {
    assignTaskToPerson: {
      anchorDate: 'Anchor date',
      assignSuccess: 'Operation package started successfully',
      assignSuccessMessage: '{{count}} people assigned',
      selectPackage: 'Select operation package',
      selectPackageDescription: 'Select the operation package you want to start',
      selectPackagePattern: 'Select operation package pattern',
      selectPackagePatternDescription: 'Select the operation package pattern you want to start',
      selectPerson: 'Select target',
      selectPersonDescription: 'Select the target to assign',
      selectPersonPlaceholder: 'Select target',
      selectedOperationPackage: 'Selected operation package',
      selectedOperationPattern: 'Selected operation package pattern',
      selectedPerson: 'Selected target',
      startOperationTask: 'Start operation package',
      startOperationTaskDescription: 'Start the operation task by selecting the operation package and pattern, and then assigning the target.',
      validationErrors: {
        noPersonSelected: 'Please select at least one person to assign',
        pastDateWithNewPerson: 'Choose the future dates when adding new people'
      }
    },
    attendanceCore: 'Time & Attendance Core',
    categories: {
      bonus_processing: 'Bonus Processing',
      mid_year_adjustment: 'Mid-Year Adjustment',
      monthly_close: 'Monthly Close',
      offboarding: 'Offboarding',
      onboarding: 'Onboarding',
      year_end: 'Year-End'
    },
    displayDataAggregate: 'View: Data summary',
    filterByPerson: 'Filter by person',
    leaveRequestPatternTabs: {
      all: 'All',
      condolenceLeave: 'Condolence / ceremonial leave',
      menstrualLeave: 'Menstrual leave',
      nursingCareLeave: 'Nursing / care leave',
      paidLeaveAdvance: 'Paid leave (advance)',
      paidLeaveAfter: 'Paid leave (after)',
      summerLeave: 'Summer leave'
    },
    mockPatternMutation: {
      description: 'Pattern changes are not available in the demo database.',
      title: 'Demo mode'
    },
    noPackages: 'No operation packages available',
    patternEmptyState: {
      description: 'No operation package pattern found. Please register from the Add pattern button above.',
      title: 'No operation package pattern'
    },
    /** Keys referenced by Dexie `AttendanceOpPackagePattern.nameKey`. */
    patternTabKeys: {
      default: 'All',
      leave_all: 'All',
      leave_condolence: 'Condolence / ceremonial leave',
      leave_menstrual: 'Menstrual leave',
      leave_nursingCare: 'Nursing / care leave',
      leave_paidAdvance: 'Paid leave (advance)',
      leave_paidAfter: 'Paid leave (after)',
      leave_summer: 'Summer leave'
    },
    shiftCoverage: {
      position: 'Position',
      requester: 'Requester',
      supportStore: 'Support store'
    },
    sideTab: {
      underDevelopment: 'This operation package is currently under development.'
    },
    sidebar: {
      absenceRequest: 'Absence request',
      article36Report: 'Article 36 agreement report',
      attendanceClosing: 'Attendance closing',
      attendanceGuidanceInterview: 'Attendance guidance interview',
      doctorInterviewGuidance: 'Doctor interview guidance',
      holidayWorkRequest: 'Holiday work request',
      leaveRequest: 'Leave request',
      overtimeCorrectionNotice: 'Overtime correction notice',
      overtimeRequest: 'Overtime request',
      paidLeaveConsumptionCall: 'Paid leave consumption reminder',
      punchRequest: 'Punch correction request',
      shiftCoverageRequest: 'Shift Coverage Request',
      shiftOrganization: 'Shift planning',
      timesheetShiftRequest: 'Timesheet & shift request'
    },
    startNew: 'Start new',
    status: {
      approval: 'Approval',
      approvalRequired: 'Approval Required',
      attachment: 'Attachment',
      completed: 'Completed',
      notRequired: 'Not Required',
      todo: 'Not Started'
    },
    steps: '{{count}} steps',
    tabs: {
      archive: 'Archive',
      config: 'Config',
      operationPackages: 'Operation packages',
      settings: 'Settings'
    },
    taskEmptyState: {
      description: 'Initiate from the start new button above.',
      title: 'No Operation task'
    },
    title: 'Operation Packages',
    types: {
      attendance: 'Attendance',
      payroll: 'Payroll',
      payroll_attendance: 'Payroll & Attendance'
    }
  },
  pageTitle: 'Time & Attendance Core',
  selectTargets: {
    clearDepartmentFilter: 'Clear the department filter',
    combinedConditions: 'Conditions: {{structureName}} · {{patternName}}',
    departmentFilter: 'Department',
    departmentFilterHint: 'Filters the demo employees in the mock DB by department (Dexie seed).',
    missingSessionDescription: 'Open “Start attendance close” from Time & Attendance Core → Business Operation Events and pick a structure and a pattern.',
    missingSessionTitle: 'No mock session',
    mockStartedToast: 'Mock started ({{structureName}} / {{patternName}}, {{count}} selected).',
    searchPlaceholder: 'Search by name or department',
    title: '{{structureName}} — {{patternName}} — Select targets'
  },
  tabs: {
    archive: 'Archive',
    config: 'Config',
    dashboard: 'Dashboard',
    operationEvents: 'Business Operation Events',
    operationPackages: 'Operation packages'
  }
};